<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <!-- Sidebar Content -->
      <div class="sidebar-content" :class="{ show: mqShallShowLeftSidebar }">
        <!-- Sidebar close icon -->
        <span class="sidebar-close-icon">
          <feather-icon
            icon="XIcon"
            size="16"
            @click="$emit('update:mq-shall-show-left-sidebar', false)"
          />
        </span>

        <!-- Header -->
        <div class="chat-fixed-search">
          <div class="d-flex align-items-center w-100">
            <!-- Search -->
            <b-input-group
              class="input-group-merge ml-0 w-100 round"
              v-show="isShowSearch"
            >
              <b-input-group-prepend is-text class="">
                <b-form-select
                  v-model="query.searchMsgType"
                  :options="searchTypeOptions"
                  size="sm"
                  class="border-0 ml-1"
                  @input="onChangeSearchType"
                />
              </b-input-group-prepend>
              <b-form-input
                v-model="query.searchKeyWord"
                v-debounce:500ms="search"
                :placeholder="$t('general.search')"
              />
            </b-input-group>
            <div class="chat-filter" v-show="!isShowSearch">
              <div class="filter">
                <h6
                  class="cursor-pointer"
                  :class="{
                    active: option.value == query.filter,
                    'cursor-wait': loading,
                  }"
                  v-for="option in filterOptions"
                  :key="option.value"
                  @click="changeFilter(option.value)"
                  style="position: relative"
                >
                  {{ $t(option.text) }}
                  <div
                    v-if="option.value == 'request' && countRoomReq >= 1"
                    style="
                      position: absolute;
                      top: -10px;
                      right: -10px;
                      min-height: unset;
                      min-width: unset;
                      height: 1rem;
                    "
                    class="badge badge-up badge-pill bg-danger"
                  >
                    {{ countRoomReq }}
                  </div>
                  <div
                    v-else-if="
                      option.value == 'joinByMe' && countRoomJoinByMe >= 1
                    "
                    style="
                      position: absolute;
                      top: -10px;
                      right: -10px;
                      min-height: unset;
                      min-width: unset;
                      height: 1rem;
                    "
                    class="badge badge-up badge-pill bg-danger"
                  >
                    {{ countRoomJoinByMe }}
                  </div>
                  <div
                    v-else-if="option.value == '' && totalCountRoom >= 1"
                    style="
                      position: absolute;
                      top: -11px;
                      right: -10px;
                      min-height: unset;
                      min-width: unset;
                      height: 1rem;
                    "
                    class="badge badge-up badge-pill bg-danger"
                  >
                    {{ totalCountRoom }}
                  </div>
                </h6>
              </div>
            </div>

            <feather-icon
              icon="SearchIcon"
              size="22"
              class="ml-1 cursor-pointer"
              :class="{
                'text-primary': isShowSearch,
              }"
              @click="searching"
            />
          </div>
        </div>
        <div class="position-relative chat-chanel-wrapper">
          <div class="chat-user-list-wrapper list-group scroll-area overflow-y">
            <ul class="chat-users-list chat-list media-list">
              <!-- <queue-alert></queue-alert> -->
              <chat-contact
                v-for="room in rooms"
                tag="li"
                :key="room.createdAt"
                :room="room"
                :is-active="activeRoom._id === room._id"
                :class="{
                  active: activeRoom._id === room._id,
                }"
                @click="onChannelChange(room)"
              />
            </ul>
            <div class="infinite-wrapper">
              <infinite-loading
                ref="infiniteLoading"
                @infinite="listRoom"
                :identifier="isConnectedChatMeRoom ? identifier : 0"
              >
                <div slot="spinner" class="mt-2">
                  <b-spinner label="Spinning"></b-spinner>
                </div>
                <div slot="no-more"></div>
                <div slot="no-results"></div>
              </infinite-loading>
            </div>
            <!-- <div v-else class="d-flex align-items-center w-100 justify-content-center mt-2">
              <b-spinner label="Spinning"></b-spinner>
            </div> -->
          </div>
        </div>
        <div class="chat-fixed-bottom border">
          <div class="d-flex align-items-center w-100 justify-content-between">
            <div>
              <!-- <b-button @click="openShortcut()" variant="link" no-caret toggle-class="p-0" right>
                <feather-icon icon="CornerDownRightIcon" size="17" class="align-middle text-body text-primary" />
              </b-button>
              <b-button @click="openSettings()" style="padding: 0 !important" variant="link" no-caret toggle-class="p-0"
                right>
                <feather-icon icon="SettingsIcon" size="17" class="align-middle text-body text-primary" />
              </b-button> -->
            </div>

            <div style="display: flex; align-items: center; position: relative">
              <!-- date filter -->
              <feather-icon
                @click="toggleDialog"
                icon="CalendarIcon"
                size="17"
                class="align-middle text-body"
                :class="{ 'text-primary': query.startDate || query.endDate }"
                style="cursor: pointer"
              />

              <!-- Fixed dialog -->
              <div
                v-if="dialogVisible"
                class="fixed-dialog"
                style="position: absolute; top: -285px; left: 0px"
              >
                <div>
                  <n-search-container
                    @search="search"
                    @reset="resetDate"
                    :show-header="false"
                    :fields="dateInputs"
                    :default-visible="true"
                  >
                    <n-search-input :fields="dateInputs" v-model="query">
                    </n-search-input>
                  </n-search-container>
                </div>
              </div>
              <div style="margin-right: 1.2rem" class="d-flex flex-row"></div>

              <!-- filter assign By -->
              <!-- <div v-if="query.searchType != 'm' || !query.search.trim()" class="d-flex flex-row">
                <div class="dropdown chat-filter-dropdown my-1">
                  <b-dropdown variant="link" no-caret toggle-class="p-0" right>
                    <template #button-content>
                      <feather-icon icon="UserIcon" size="17" class="align-middle text-body text-primary" v-if="query.type == 'assignToMe' ||
                        (query.type == 'allConversation' &&
                          query.operator == userData.id)
                        " />
                      <feather-icon icon="UserIcon" size="17" class="align-middle text-body" v-else-if="query.type == 'allConversation' && query.operator
                        " />
                      <feather-icon icon="UsersIcon" size="17" class="align-middle text-body"
                        v-else-if="query.type == 'allConversation'" />
                      <feather-icon icon="UserXIcon" size="17" class="align-middle text-body" v-else />
                    </template>
                    <b-dropdown-item @click="changeOperator('assignToMe')">
                      {{ $t("chat.assignToMe") }}
                      <feather-icon class="float-right" icon="CheckIcon" size="22" v-if="query.type == 'assignToMe'" />
                    </b-dropdown-item>
                    <b-dropdown-item @click="changeOperator('unassign')">
                      {{ $t("chat.unassign") }}
                      <feather-icon class="float-right" icon="CheckIcon" size="22" v-if="query.type == 'unassign'" />
                    </b-dropdown-item>
                    <b-dropdown-item @click="changeOperator('allConversation')">
                      {{ $t("chat.allConversation") }}
                      <feather-icon class="float-right" icon="CheckIcon" size="22" v-if="query.type == 'allConversation'" />
                    </b-dropdown-item>

                    <b-dropdown-divider v-show="query.type == 'allConversation'"></b-dropdown-divider>

                    <b-dropdown-form v-show="query.type == 'allConversation'">
                      <b-form-group>
                        <label class="d-block">
                          {{ $t("field.operator") }}
                        </label>
                        <n-async-single-select v-model="query.operator" :init-options="query.operator" repository="chatOperator"
                          selection-key="id" selection-label="name" :clearable="true" @input="onChangeOperator"></n-async-single-select>
                      </b-form-group>
                    </b-dropdown-form>
                    </b-dropdown>
                    </div>
                    </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <chat-settings-model ref="openSettingsModal" @reloadChannel="reloadData" />
    <chat-shortcut-model ref="openShortcutModal" />
  </div>
</template>

<script>
import {
  BModal,
  BAvatar,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
  BSpinner,
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BDropdownForm,
  BFormGroup,
  BFormRadioGroup,
  BFormRadio,
  BFormSelect,
} from "bootstrap-vue";
import ChatContact from "./ChatContact.vue";
import InfiniteLoading from "vue-infinite-loading";
import NAsyncSingleSelect from "@/components/NAsyncSingleSelect";
import ChatSettingsModel from "./ChatSettingsModel.vue";
import ChatShortcutModel from "./ChatShortcutModel.vue";
import { bus } from "@/libs/bus";
import useJwt from "@/auth/jwt/useJwt";
import QueueAlert from "@/components/QueueAlert.vue";
import NSearchContainer from "@/components/NSearchContainer";
import NSearchInput from "@/components/NSearchInput";
import DateInputs from "./searchDate.js";
import useChatPartnerStore from "@/store-pinia/useChatPartnerStore";

import store from "@/store";
import ComingConversationLineChart from "../conversationOverview/ComingConversationLineChart.vue";

export default {
  components: {
    NSearchContainer,
    NSearchInput,
    // BSV
    BModal,
    BAvatar,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    BSpinner,
    BDropdown,
    BDropdownDivider,
    BDropdownItem,
    BDropdownForm,
    BFormGroup,
    BFormRadioGroup,
    BFormRadio,
    BFormSelect,
    QueueAlert,

    // 3rd party
    InfiniteLoading,

    // SFC
    ChatContact,
    NAsyncSingleSelect,

    // Component
    ChatSettingsModel,
    ChatShortcutModel,
  },
  props: {
    rooms: {
      type: Array,
      default: () => [],
    },
    activeRoom: {
      type: Object,
      default: () => {},
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
    connectionStatus: {
      type: Boolean,
      default: true,
    },
    identifier: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    userData: function () {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
    countRoomReq() {
      return this.chatPartnerStore.countRoom.request;
    },
    countRoomJoinByMe() {
      return this.chatPartnerStore.countRoom.joinByMe;
    },
    totalCountRoom() {
      return (
        this.chatPartnerStore.countRoom.request +
        this.chatPartnerStore.countRoom.joinByMe
      );
    },
    isConnectedChatMeRoom() {
      return this.chatPartnerStore.isConnectedChatMeRoom;
    },
  },
  data() {
    return {
      isShowSearch: this.$route.query.search ? true : false,
      assignIcon: "UserIcon",
      filterOptions: [],
      query: {
        searchKeyWord: this.$route.query.searchKeyWord || "",
        searchMsgType: this.$route.query.searchMsgType || "r",
        // operator: this.$route.query.operator || null,
        // type:
        //   this.$route.query.type ||
        //   store.state.app.chatQuery.type ||
        //   "allConversation",
        filter: this.$route.query.filter || "",
      },
      searchTypeOptions: [
        // { value: "m", text: this.$t("general.message") },
        { value: "r", text: this.$t("general.room") },
      ],
      dialogVisible: false,
    };
  },
  created() {
    const chatQuery = {};
    this.$nextTick(() => {
      this.mapFilterOption(this.query.type);
      this.changeFilter(this.query.filter);

      bus.$on("notificationClick", (type) => {
        if (type == "chat") {
          this.mapFilterOption(this.query.type);
          this.changeFilter(this.query.filter);
        }
      });
    });
  },
  beforeDestroy() {
    bus.$off("notificationClick");
  },
  methods: {
    reset() {
      this.$refs.search.reset();
      this.updateQuerySting();
    },
    resetDate() {
      return;
      this.query.startDate = "";
      this.query.endDate = "";
      this.updateQuerySting();
      this.toggleDialog();
      this.$emit("filter", this.query);
    },
    toggleDialog() {
      this.dialogVisible = !this.dialogVisible;
    },
    reloadData() {
      this.$emit("close-room", {});
      this.search();
    },
    openSettings() {
      this.$refs.openSettingsModal.show();
    },
    openShortcut() {
      this.$refs.openShortcutModal.show();
    },
    listRoom($state = null) {
      if (!this.isConnectedChatMeRoom) return;
      this.$emit("load-room", $state);
    },
    onChangeOperator() {
      this.query.search = "";
      this.query.filter = "";
      this.updateQuerySting();
      this.$emit("filter", this.query);
    },
    onChangeSearchType() {
      this.updateQuerySting();
      this.$emit("filter", this.query);
    },
    onChannelChange(room) {
      this.$emit("open-chat", room);
    },
    changeFilter(filter) {
      // return; //temp command
      if (this.loading) return;
      this.query.filter = filter;
      this.updateQuerySting();
      this.$emit("filter", this.query);
    },
    changeOperator(type) {
      this.query.search = "";
      this.query.filter = "";
      this.query.operator = "";
      this.mapFilterOption(type);
      this.query.type = type;
      this.updateQuerySting();
      this.$emit("filter", this.query);
    },
    mapFilterOption(type) {
      if (type == "unassign") {
        this.filterOptions = [];
      } else {
        this.filterOptions = [
          {
            value: "",
            text: "chat.all",
          },
          {
            value: "request",
            text: "chat.request",
          },
          {
            value: "joinByMe",
            text: "chat.joinByMe",
          },
          // {
          //   value: "resolved",
          //   text: "chat.resolved",
          // },
          // {
          //   value: "banned",
          //   text: "chat.banned",
          // },
        ];
      }
    },
    searching() {
      this.isShowSearch = !this.isShowSearch;
      if (!this.isShowSearch && this.query.searchKeyWord) {
        this.query.searchKeyWord = "";
        this.search();
      }
    },
    search() {
      this.updateQuerySting();
      this.$emit("filter", this.query);
      this.dialogVisible = false; //dialog filter Date
    },
    updateQuerySting() {
      this.$router.replace({ query: this.query });
      // this.$nextTick(() => {
      //   if (this.query.cache != "no") {
      //     store.commit("app/UPDATE_CHAT_QUERY", {
      //       ...this.query,
      //       channel: undefined,
      //     });
      //   }
      // });
    },
  },
  setup() {
    const chatPartnerStore = useChatPartnerStore();

    return {
      chatPartnerStore,
      dateInputs: DateInputs,
    };
  },
};
</script>

<style scoped>
.input-group-text {
  padding: 0 !important;
}

.custom-select:focus {
  box-shadow: none !important;
}

.fixed-dialog {
  position: fixed;
  height: 274px;
  top: 100px;
  left: 400px;
  width: 258px;
  z-index: 1000;
  background-color: #fff;
  border: 0px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.cursor-wait {
  cursor: wait;
}
</style>
